module.exports = __webpack_public_path__ + "img/watage_0.03f83320.png";